var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.$global.imgUrl + _vm.column.advertImg),expression:"$global.imgUrl + column.advertImg"}],staticClass:"column-container",on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }